export const PackageTypeMap: {
  [key: string]: string;
} = {
  HWRK: 'home-worker',
  RES: 'residential',
  BUS: 'business',
  MSM: 'multi-dwelling',
};
